import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { SecondaryCriteriaElementType } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editSecondaryCriteriaTemplate(
    request: Boundaries["editSecondaryCriteriaTemplate"]["request"],
  ): void;
}

function useEditSecondaryCriteriaTemplate(
  namespace: string,
  type: SecondaryCriteriaElementType,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditSecondaryCriteriaTemplateRequestPending(namespace, type),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditSecondaryCriteriaTemplateRequestSuccess(namespace, type),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditSecondaryCriteriaTemplateRequestFailure(namespace, type),
    ),
    editSecondaryCriteriaTemplate: core.editSecondaryCriteriaTemplate,
  };
}

export { useEditSecondaryCriteriaTemplate };
